module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-techo-29cd05e82d55b72d2cedc8c72ab29eda.jpg";